import { useLocalSearchParams } from 'expo-router';
import TeamDetailLayout from '@/layouts/TeamDetail';

export default function PrivateTabsEventTeamTeamIdLayoutRoute() {
  const { teamId } = useLocalSearchParams<{ teamId: string }>();

  return (
    <TeamDetailLayout
      basePath="/event/team/[teamId]"
      badgesPathname="/event/team/[teamId]/badge"
      teamId={teamId}
    />
  );
}
